<app-page-overlay (closeOverlay)="onCancel()">

  <div class="persistent-wrapper">
    <app-heavy-header title="Always On - Agent Watchers"
      description='In addition to finding specific travel plans with the AI agent, these watchers will always watch and email you when similar travel plans are found.'></app-heavy-header>

    <div class="input-section" *ngIf="!isLoading">
      <div class="input-label">
        Email me when flights are found for:
      </div>
      <div class="ai-input-row">
        <app-base-input id="input-el" placeholder="Ex: Dallas to LA, 2 seats, no pets"
          [(ngModel)]="prompt" (onEnter)="onSubmit()" isFluid="true" hasIcon="true" autocomplete="off"></app-base-input>
          <div class="sub-text">Just tell the AI agent the details and it will build the watcher for you.</div>

        <div class="action-button" (click)="onSubmit()"
          [ngClass]="{ 'active' : prompt.length > 1 && prompt.length < 2000}">
          <app-svg-loader url="assets/svg/circle-arrow-up.svg"></app-svg-loader>
        </div>

      </div>
    </div>

    <div *ngIf="error" class="error">{{error}}</div>

    <div class="typing-wrapper" *ngIf="isLoading">
      <app-ai-typing></app-ai-typing>
    </div>

    <div *ngIf="!isLoading && agentText">
      <div class="exchange-info">
        <div class="exchange-avatar">
          <app-svg-loader height="32px" url="assets/logos/tail-one-logo-chip-gradient-black.svg"></app-svg-loader>
        </div>
        <div class="exchange-text">
          {{agentTypedText}}
        </div>
      </div>
    </div>

    <div class="watcher-list" *ngIf="previewWatchers.length > 0">
      <app-watcher-card *ngFor="let watcher of previewWatchers; trackBy: trackByPreviewWatcher" [watcher]="watcher"
        [persistent]="true" [allowPreviewMenu]="true"
        (handleDeleteWatcher)="onRemoveWatcher($event)"></app-watcher-card>

      <app-primary-btn gradient="true" (click)="onConfirmAll()" [disabled]="isSaving || isLoading"
        [isLoading]="isSaving || isLoading">
        Add {{previewWatchers.length}} Watcher<span *ngIf="previewWatchers.length > 1">s</span>
      </app-primary-btn>

    </div>


  </div>

</app-page-overlay>